var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3072 17.6154C20.6193 17.6154 24.1149 14.1198 24.1149 9.80771C24.1149 5.49563 20.6193 2 16.3072 2C11.9951 2 8.49951 5.49563 8.49951 9.80771C8.49951 14.1198 11.9951 17.6154 16.3072 17.6154Z",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 31.9226L2.50416 29.1293C3.09975 25.9033 4.8066 22.9879 7.32819 20.8894C9.84979 18.791 13.0268 17.6422 16.3073 17.6426C19.5917 17.6434 22.7719 18.796 25.294 20.8999C27.8161 23.0038 29.5205 25.9256 30.1105 29.1566L30.6146 31.9499",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.354284816f897bacff254c4ecd2d6e61.svg";
export { ForwardRef as ReactComponent };